module.exports = __webpack_public_path__ + "30164db2e489f1275577dab3b7f69399.MP3";